import * as React from 'react';
import { Redirect } from 'react-router-dom';

import Modal from 'react-awesome-modal';
import Loader from 'react-loader';

import withServices from '../../../../HOCs/withServices';
import PlexPathway from '../../../../components/OnBoard/Plexing/PlexPathways/PlexPathways.Component';
import DailyGoal from '../../../../components/OnBoard/Plexing/DailyGoal/DailyGoal.Component';
import CustomNav from '../../../../components/CustomNav/CustomNav.Component';
import { Container } from '../../Common/Common.styles';
import { ContentWrapper, IconWrapper } from '../../UserEngagement/UserEngagement.styles';
import { StyledRow } from './Plexing.styles';



import casual from '../../../../assets/images/onboard/casual-icon.svg';
import insane from '../../../../assets/images/onboard/insane-icon.svg';
import regular from '../../../../assets/images/onboard/regular-icon.svg';
import serious from '../../../../assets/images/onboard/serious-icon.svg';
import { toast } from 'react-toastify';

interface IProps {
    services?: any;
    history?: any;
}

interface IState {
    navigate: boolean;
    destination: string;
    plexPathways: any;
    localStoragePathways:  any;
    modalOpen: boolean;
    dailyGoalQuestions: any;
    dailyGoal: number
}

const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
const icons = {
    "casual": casual,
    "insane": insane,
    "regular": regular,
    "serious": serious,
}

class Plexing extends React.Component<IProps, IState> {
    private ls = window.localStorage;

    constructor(props){
        super(props);
        this.state = {
            navigate: false,
            destination:  '',
            plexPathways: [] as any,
            localStoragePathways: [] as any,
            modalOpen : false, 
            dailyGoalQuestions: [] as any,
            dailyGoal: 0
        }
       this.renderDailyGoalTile = this.renderDailyGoalTile.bind(this);
       this.convertToMins = this.convertToMins.bind(this);
       this.lessonClicked = this.lessonClicked.bind(this);
       this.renderEditGoalModal = this.renderEditGoalModal.bind(this);
       this.editGoal = this.editGoal.bind(this);
       this.updateDailyGoal = this.updateDailyGoal.bind(this);
    }

    public async componentDidMount() {
        // this.ls.clear();
        if(this.ls.getItem('onboardingcompleted') === null) {
            this.setState({navigate: true, destination: `onboarding/getstarted`});
        }

        const storedPathways = this.ls.getItem('storedpathways3');
        const {services: { fixturesAPI, adminAPI }} = this.props;

        const categories = ['easy', 'medium', 'hard', 'very hard', 'genius'];

        if(storedPathways === null) {
            // first time, no lessons in localstorage
            const res = await adminAPI.getOnboardingItems();
            if(res.ok) {
                const lessons = res.data.lessons;
                const pathways = new Array();
                let idx = 1;
                for(const category of categories){
                    pathways.push(
                        {
                        id: idx ,
                        'category-name': category,
                        lessons
                    }
                    )
                    idx += 1;
                }
            console.log(JSON.stringify({pathways}, null, 4));
            this.setState({plexPathways: pathways});
            this.ls.setItem('storedpathways3', JSON.stringify(pathways));
            }else {
                toast.error("No lessons available right now");
            }
        }else {
            // items from local storage
            const plexPathways = JSON.parse(storedPathways);
            this.setState({plexPathways});
        }
        // questions for editing daily goal
        const response = await fixturesAPI.getUserOnboardingQuestions('student');
        const questionSets = response.questionSets;
        const dailyGoalQuestions = questionSets.filter(questionSet => questionSet.metric === 'dailygoal');
        this.setState({dailyGoalQuestions});
    }

    public lessonClicked(lessonId, difficulty) {
        const { history } = this.props;
        history.push(`/plexing/lesson/${difficulty}/${lessonId}`);
    }
    public editGoal() {
        this.setState({ modalOpen: !this.state.modalOpen });
    }

    public updateDailyGoal(val) {
        this.ls.setItem('dailygoal', `${val}`);
        const modalOpen = this.state.modalOpen;
        this.setState({dailyGoal: val, modalOpen: !modalOpen});
        this.forceUpdate();
    }

    public toSignUp = () => {
        const { history } = this.props;
        history.push('/onboarding/register/student')
    }

    public resetDailyVals() {
        // initialize & set daily goal vals to 0 in localstorage
        // call beginning of new week
        // this.ls.setItem('sun', '0');
        this.ls.setItem('mon', '0');
        this.ls.setItem('tue', '0');
        this.ls.setItem('wed', '0');
        this.ls.setItem('thu', '0');
        this.ls.setItem('fri', '0');
        this.ls.setItem('sat', '0');
    }

    public renderDailyGoalTile() {
        // get current daily goal values
        const data = new Array();
        const formatedData = new Array();
        const today = new Date().getDay(); // returns index of today, 0-6(sun-sat)
        if(today === 0) { 
           // reset previous week metrics
            this.resetDailyVals();
        }

        weekdays.forEach((day, i) => {
            data.push(
                {
                    x: day,
                    y : this.convertToMins(day)
                }
            )
        });

        formatedData.push(
            {
                data
            }
        )
        return(
            <DailyGoal data={formatedData} editGoal = {this.editGoal}/>
        )
    }

    public renderEditGoalModal() {
        const { dailyGoalQuestions } = this.state;
        if(dailyGoalQuestions.length){
            return(
                <Modal
                    visible = {this.state.modalOpen}
                    effect = "fadeInLeft"
                    onClickAway = {this.editGoal}
                    styles={{ backgroundColor: "transparent" }}
                    container={{ background: "#ff0033" }}
                >
                    <div className="edit-modal">
                        <h1>{dailyGoalQuestions[0].question}</h1>
                        <ContentWrapper>
                            {dailyGoalQuestions[0].responses.map((response) =>
                                <IconWrapper key={response.id} onClick={this.updateDailyGoal.bind(this, response.value)}>
                                    <div className="icon-wrap">
                                        <img src={icons[response.icon]} alt="" />
                                    </div>
                                    <p className="icon-description">{ response.text }</p>
                                </IconWrapper>
                            )}
                        </ContentWrapper>
                    </div>
                </Modal>
            )
        }else {
            return <Loader color="#ff0033" />
        }
    }

    public convertToMins(day) {
        const dayVal = this.ls.getItem(day);
        if(dayVal === null) {
            return 0;
        }else {
            return parseInt(dayVal, 10);
        }
    }
    public render(){
        const { plexPathways } = this.state;
        console.log("Plexpathways: " + JSON.stringify(plexPathways, null, 4))
        if(this.state.navigate){
            return <Redirect to={this.state.destination} />
        }
        return (
          <Container>
            <CustomNav {...this.props} designation="onboarding" />
            <StyledRow>
              {this.renderEditGoalModal()}
              <div className="pathways-container">
                {plexPathways.map((pathway) => (
                  <PlexPathway
                    key={pathway.id}
                    data={pathway}
                    onLessonClick={this.lessonClicked}
                    allLessons={plexPathways}
                  />
                ))}
              </div>
              <div className="pathways-metrics">
                {this.renderDailyGoalTile()}
                <div className="signup-tile">
                  <p>
                    Sign Up now for the complete <br /> Performance Learning
                    experience
                  </p>
                  <button
                    className="onboard-signup green-button"
                    onClick={this.toSignUp}
                  >
                    Sign Up
                  </button>
                </div>
              </div>
            </StyledRow>
          </Container>
        );
    }
}

export default withServices(Plexing);


// WEBPACK FOOTER //
// ./src/pages/Onboard/Student/PlexPathways/Plexing.Component.tsx